import styled from "styled-components";
import { Copy as StyledIconsCopy } from "styled-icons/boxicons-regular";

export const Copy = styled(StyledIconsCopy)`
	:hover {
		cursor: pointer;
		user-select: none;
	}
`
